import React from 'react';
import AdminBottomNav from '../../components/AdminBottomNav';
import StaffScanSurface from '../../components/staff/StaffScanSurface';

export default function AdminScanPage() {
  return (
    <StaffScanSurface
      basePath="/staff-admin"
      bottomNav={<AdminBottomNav />}
      pageTestId="admin-scan-page"
      testIdPrefix="admin"
      roleLabel="Admin staff"
    />
  );
}
